import { render, staticRenderFns } from "./groupsList.vue?vue&type=template&id=41ef0015"
import script from "./groupsList.vue?vue&type=script&lang=ts"
export * from "./groupsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports